// extracted by mini-css-extract-plugin
export default {"main":"main__yJzGp","head":"head__0BlWQ","info-box":"info-box__3nFNf","icon":"icon__khHAn"};